"use client"

import { Navigate, useLocation } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux" // Import useDispatch
import { useEffect } from "react" // Import useEffect
import { fetchLoggedInUserStatus } from "../slices/authSlice" // Import the new thunk

const ProtectedRoute = ({ children }) => {
  const { userInfo } = useSelector((state) => state.auth)
  const location = useLocation()
  const dispatch = useDispatch() // Initialize useDispatch

  useEffect(() => {
    // If user is logged in, check their status whenever this protected route is accessed
    // This ensures that if a user is suspended while active, they get logged out
    // when they try to navigate to another protected page.
    if (userInfo) {
      dispatch(fetchLoggedInUserStatus())
    }
  }, [userInfo, dispatch, location.pathname]) // Re-run when userInfo changes or route changes

  if (!userInfo) {
    // Redirect to login if not logged in, and save the location they were trying to access
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

export default ProtectedRoute
